import { useState } from 'react'

type TabItem = {
  label: string
  content: React.ReactNode
}

interface TabsProps {
  tabs: TabItem[]
}

const Tabs: React.FC<TabsProps> = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0)

  return (
    <div className='w-full h-full overflow-y-auto spec-scroll'>
      <div className='sticky top-0 z-50 mb-2'>
        <div className='flex justify-around text-center bg-primary border-b border-disable'>
          {tabs.map((tab, index) => (
            <button
              key={index}
              className={`w-full text-kpi-heading p-padding-xl font-semibold px-padding-3xl py-2 focus:outline-none ${
                activeTab === index
                  ? 'border-b-2 border-b-primary-active-foreground text-primary-active-foreground'
                  : 'text-primary-foreground'
              }`}
              onClick={() => setActiveTab(index)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
      <div className='h-full'>{tabs[activeTab]?.content}</div>
    </div>
  )
}

export default Tabs
